import React, { useRef, useState } from 'react';

//components
import BasicButton from './BasicButton';

//interfaces
import { IToggleSelectButton, IToggleSelectButtonListItem } from '../../../interfaces/buttons/ToggleSelectButton';
import { Direction } from '../../../interfaces/toggles/IToggle';

//helpers
import { toggleIcon } from '../../../helpers/Toggle';
import { useClickAwayClose } from '../../../hooks/useClickAwayClose';



const ToggleSelectButton = ({selectedItem, defaultTitle, className, ariaLabel, toggleDisabled = false, buttonList}: IToggleSelectButton) => {
    const ref = useRef<HTMLDivElement>(null);
    const [showToggleList, setShowToggleList] = useState<boolean>(false);
    useClickAwayClose(showToggleList, ref, () => {setShowToggleList(false)});
    
    return (
        <div className={'toggle-select-container'} ref={ref}>
            <BasicButton
                content={
                    <span className='toggle-select-button-content'>
                        <span className="toggle-select-label">
                            {selectedItem?.text || defaultTitle || ""}
                        </span>
                        <span className="toggle-select-icon">
                            {toggleIcon(Direction.BOTH)}
                        </span>
                    </span>
                }
                ariaLabel={ariaLabel} 
                className={`toggle-select-button ${className ?? ""}`}
                isDisabled={toggleDisabled || !buttonList || !buttonList?.length} 
                onButtonClick={() => setShowToggleList(!showToggleList)}
            />

            {showToggleList && buttonList && buttonList.length > 0 &&
                <div className={`toggle-select-button-list ${buttonList.length === 1 ? "single-button" : ""}`}>
                    {buttonList?.map((button: IToggleSelectButtonListItem, index: number) => (
                        <BasicButton
                            key={index}
                            className={`toggle-select-button-list-item ${button.id === selectedItem?.id ? "toggle-select-button-selected" : ""} `}
                            content={button.text}
                            ariaLabel={button.label}
                            isDisabled={button.isDisabled}
                            onButtonClick={() => {
                                setShowToggleList(!showToggleList);
                                button.onButtonClick?.();
                            }}
                        />
                    ))} 
                </div>
            }
        </div>
    );
};

export default ToggleSelectButton